// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"211":"272b0242","768":"24258777"}[chunkId] + ".css";
};